import { AppNS } from 'app';
import { can } from 'app/helpers/can';
import { isBackoffice, isClient } from 'app/helpers/userRoles';
import MagnifierIcon from 'app/ui/icons/MagnifierIcon';
import AddIcon from 'app/ui_v2/icons/AddIcon';

import { Box } from '@mui/material';

import ToolbarButton from './ToolbarButton';

export interface ToolbarCallToActionProps {
  user: AppNS.User;
  currentApp: string;
}

export default function ToolbarCallToAction(props: ToolbarCallToActionProps) {
  const { user, currentApp } = props;

  return (
    <>
      {isClient(user) &&
        can(user, 'manage_projects') &&
        currentApp === 'third-party' && (
          <Box mr={2}>
            <ToolbarButton
              url="/client/job-create"
              icon={<MagnifierIcon />}
              label="Find an Inspector"
            />
          </Box>
        )}
      {(isClient(user) || isBackoffice(user)) &&
        currentApp === 'dcra-inspections' && (
          <Box mr={2}>
            <ToolbarButton
              url="/dcra-inspections/inspection-create"
              icon={<AddIcon />}
              label="Schedule an Inspection"
            />
          </Box>
        )}
    </>
  );
}
